import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import type {
  CustomerAgentsResponse,
  CustomersListResponse,
} from "@/types/api";

export function useCustomers() {
  return useQuery({
    queryKey: ["customers"],
    queryFn: ({ signal }) =>
      apiFetch<CustomersListResponse>("/api/customers", { signal }),
    staleTime: 30_000,
  });
}

export function useCustomerAgents(customerId: string | null) {
  return useQuery({
    queryKey: ["customer-agents", customerId],
    enabled: customerId !== null,
    queryFn: ({ signal }) =>
      apiFetch<CustomerAgentsResponse>(
        `/api/customers/${customerId}/agents`,
        { signal },
      ),
    staleTime: 15_000,
  });
}
